import { IconSearchStyled, WrapIcon } from "./style";

export const MenuSearch = () => {
  return (
    <WrapIcon>
      <IconSearchStyled />
      Pesquisar
    </WrapIcon>
  );
};
